/**
 * Full-viewport branded loading state. Used while the cloud shell resolves
 * the session or a project. The lightning mark breathes; a spinner sits
 * below it. Replaces the bare "Loading…" text.
 */

import { BliksysMark } from './BliksysMark.js';
import { Spinner } from './Spinner.js';
import './LoadingScreen.css';

export function LoadingScreen({ message = 'Loading…' }: { message?: string }): JSX.Element {
  return (
    <div className="loading-screen">
      <div className="loading-screen-mark" aria-hidden="true">
        <BliksysMark size={44} color="var(--accent-blue)" />
      </div>
      <Spinner size={20} />
      <p className="loading-screen-message">{message}</p>
    </div>
  );
}
